var initializeColorPicker = function (controlId, defaultColorId, labels) {
  const control = $('#' + controlId);
  const formId = control.attr("data-target-form-id");
  const radios = $("#" + controlId + " input.custom-option-color-picker-pill");  
  for (var i = 0; i < radios.length; i++) {
    radios[i].addEventListener("change", function (event) {
      updateColorPickerValue(controlId, $(event.target).attr('data-code'));
    });
  }
  setColorPickerValue(controlId, defaultColorId);
};

var setColorPickerValue = function (controlId, colorCode) {

   const radio = $("#" + controlId + " input.custom-option-color-picker-pill[data-code='" + colorCode + "']");  
   radio.prop("checked", true)
   updateColorPickerValue(controlId, colorCode);  
}; 

var updateColorPickerValue = function(controlId, colorCode)
{
  const control = $('#' + controlId);
  const radio = $("#" + controlId + " input.custom-option-color-picker-pill[data-code='" + colorCode + "']");  
  const valueInput = $("#" + controlId + "-value");
  const colorName = radio.attr("value");
  valueInput.val(colorName);  
  const label = $("#" + controlId + " .custom-option-color-picker-selected-label");  
  label.text(colorName)
  const swatch = control.attr("data-swatch");
  if(!TTG.Strings.isEmptyOrWhiteSpaces(swatch))
  {
     const swatchPreview = $("#" + controlId + " .custom-option-color-picker-color-preview img");
     var url = TTG.formatStringWithObject(swatch, { colorid: colorCode })
     swatchPreview.attr("src", url);
  }
}
